module.exports = __webpack_public_path__ + "static/homepage-hero-768-3c3ea50bde9e6a21bceb1657d037abc5.jpg";